import { isNil } from 'lodash';
import { MODULE_PARAM_NAME } from 'config/routes';
import { ACCOUNT_ID } from 'hooks/queryParams/useSelectedAccountId';
import { queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';
import { PERSISTENCE_TYPE } from 'modules/taboola-common-frontend-modules/storage';
import { AllEntityId } from '../config/allEntityId';

export const reportEntityTypeDeserializer = val => {
    if (isNil(val)) {
        return val;
    }

    const parseVal = parseInt(val);
    if (Number.isNaN(parseVal)) {
        return val;
    }

    return parseVal;
};
export const REPORT_ENTITY_TYPE = 'reportEntityType';

export const useReportEntityType = queryParamHookFactory(REPORT_ENTITY_TYPE, {
    deserializer: reportEntityTypeDeserializer,
    persist: PERSISTENCE_TYPE.MEMORY,
    defaultValue: AllEntityId,
    dependencies: {
        queryParams: [ACCOUNT_ID],
        pathParams: [MODULE_PARAM_NAME],
    },
});
